import { useState, useCallback } from "react";
import Cookies from "universal-cookie";

import { CHALLENGE, USERNAME, EMAIL_HINT } from "constants/login";

const cookies = new Cookies();
export const setCookie = (...args) => cookies.set(...args);
export const getCookie = (key) => cookies.get(key);

const useCookie = (key, initialValue) => {
  const [item, setInnerValue] = useState(
    () => cookies.get(key) || initialValue
  );

  const setValue = useCallback(
    (value, options) => {
      if (value) {
        setInnerValue(value);
        cookies.set(key, value, options);
      }
    },
    [key]
  );

  return [item, setValue];
};

const useCookies = () => {
  const [userDataEncrypted] = useCookie(EMAIL_HINT, cookies.get(EMAIL_HINT));
  const [email, setEmail] = useCookie(USERNAME, cookies.get(USERNAME));
  const [loginChallenge, setLoginChallenge] = useCookie(
    CHALLENGE,
    cookies.get(CHALLENGE)
  );

  let emailHint, customerId;

  try {
    const userData = JSON.parse(atob(userDataEncrypted));
    emailHint = userData.email_hint_text;
    customerId = userData.customer_id;
  } catch (err) {}

  return {
    loginChallenge,
    setLoginChallenge,
    email,
    setEmail,
    emailHint,
    customerId,
  };
};

export default useCookies;
